export default "__VITE_ASSET__wGuaqRrJ__"